import { render } from "./ButtonBase.vue?vue&type=template&id=42c002b6&scoped=true"
import script from "./ButtonBase.vue?vue&type=script&lang=js"
export * from "./ButtonBase.vue?vue&type=script&lang=js"

import "./ButtonBase.vue?vue&type=style&index=0&id=42c002b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c002b6"]])

export default __exports__